<template>
  <div class="" v-show="show">
    <div id="mask2"></div>
    <div class="nstl-templet-div2">
  
     <div class=" modal-dialog bankbg modal-dialog03 clearfix">
      <div>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closePay()"
            style="float:right;border:none;font-size: 30px;margin-right: 5px;background-color: #e5d7d308;">×</button>
      </div>
     
        <div class="modal-header" style="margin-top: 20px;">
          <h3 class="modal-title">微信扫码支付</h3>
        </div>
        <div class="modal-body clearfix" style="margin-top: 20px;">
          <div id="_scanCodePay_alipay" class="code text-center">
            <div class="weixinpanDiv"> 支付成功之前，请勿关闭二维码页面。</div>
            <div id="qrcode" style="margin-top: 10px;"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean,
    text: {
      type: String,
      default: '正在加载中...'
    },
  },
  methods: {
    closePay() {
      // this.$messageTips.hide()
      this.show = false
    }
  },
}
</script>
<style scoped>
  .modal-title{
    font-weight: 700;
    font-size: 16px;
  }
</style>
<style >
@import "../../../static/cart/css/base.css";
@import "../../../static/cart/css/cart.css";
/* @import "../../../static/common/css/iconfont.css"; */
</style>



// WEBPACK FOOTER //
// src/assets/components/messageTips.vue